import { StandardDialog } from '@roc/ui';
import { useDocumentStore } from '@roc/feature-documents';
import { Document } from '@roc/feature-types';
import { LoanPayments } from './loanPayments';
import { TaskStatus } from '@roc/feature-general-tasks';

export type LoanPaymentsDialogProps = {
  open?: boolean;
  onClose?: () => void;
  loan: any;
  document: Document;
};

export const LoanPaymentsDialog = (props: LoanPaymentsDialogProps) => {
  const { open, onClose, loan, document } = props;

  const { documentStore } = useDocumentStore();
  const { documentFormStore } = documentStore;
  const { loanPaymentsStore } = documentFormStore;

  const onClick = () => {
    document.status = TaskStatus.ACCEPTED;
    loanPaymentsStore.acceptDocument(document);
  };

  return (
    <StandardDialog
      open={open}
      title="Due Diligence Payment"
      maxWidth="md"
      handleClose={onClose}
      dialogContent={
        <LoanPayments
          loan={loan}
          document={document}
          onSubmitLoanPayments={onClose}
          onClick={onClick}
        />
      }
    />
  );
};

export default LoanPaymentsDialog;
